import { z } from "zod";

// Team Form Schema
export const TeamFormSchema = z.object({
  team_name: z.string().min(1, "Team name is required"),
  team_description: z.string().optional(),
  team_lead_uuid: z.string().optional(),
});

export type TeamFormData = z.infer<typeof TeamFormSchema>;

// Team Detail Interface
export interface TeamDetail {
  uuid: string;
  team_name: string;
  team_description?: string;
  team_lead_uuid?: string;
  parent_team_uuid?: string;
  is_active: boolean;
  team_created_at: Date;
  team_updated_at: Date;
  
  // Relationships
  teamLead?: {
    uuid: string;
    userName: string;
    userEmail: string;
  };
  parentTeam?: {
    uuid: string;
    team_name: string;
  };
  subTeams?: TeamDetail[];
  members?: {
    uuid: string;
    userName: string;
    userEmail: string;
    role?: {
      uuid: string;
      role_name: string;
    };
  }[];
}

// Team Hierarchy Interface (for tree views)
export interface TeamHierarchy extends TeamDetail {
  children: TeamHierarchy[];
}

// Team API Data
export interface TeamsApiData {
  teams: TeamDetail[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
  links: {
    first: string;
    last: string;
    next?: string;
    prev?: string;
  };
}

// Create Team Request
export interface CreateTeamRequest {
  team_name: string;
  team_description?: string;
  team_lead_uuid?: string;
  parent_team_uuid?: string;
}

// Update Team Request
export interface UpdateTeamRequest extends CreateTeamRequest {
  // Same as create for now
}